import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../../components/layout';
import HowToUse from '../../components/HowToUse';
import { genHowToUseBreadcrumbJsonLd } from '../../utils/jsonld';

const meta = {
  en: {
    title: 'Resize images to same width - EverTool',
    subtitle: 'The tutorial of resize images to same width by EverTool',
  },
  'zh-tw': {
    title: '將圖片縮至相同大小 - EverTool',
    subtitle: '教你如何在 EverTool 將所有圖片縮至相同大小',
  },
  'zh-cn': {
    title: '将图片缩至相同大小 - EverTool',
    subtitle: '教你如何在 EverTool 将所有图片缩至相同大小',
  },
  ja: {
    title: '同じ幅に画像のサイズを変更 - EverTool',
    subtitle: 'EverToolによって同じ幅にリサイズ画像のチュートリアル',
  },
};


class ResizeImagePage extends React.Component {
  constructor(props) {
    super(props);
    const { data } = props;
    const config = {
      images: {
        mac: {
          intro1: [data.mac_step1],
          intro2: [data.mac_step2],
          intro3: [data.mac_step3],
        },
        win: {
          intro1: [data.win_step1],
          intro2: [data.win_step2],
          intro3: [data.win_step3],
        },
      },
      introId: {
        title: 'resize.title',
        step1: 'resize.step1',
        step2: 'resize.step2',
        step3: 'resize.step3',
      },
    };

    this.state = {
      config,
    };
  }

  render() {
    const { pageContext } = this.props;
    const { config } = this.state;
    const { locale, url } = pageContext;

    return (
      <Layout
        pageContext={pageContext}
        seo={{
          title: meta[locale].title,
          subtitle: meta[locale].subtitle,
          hreflangs: pageContext.hreflangs,
          url,
          locale,
          jsonld: genHowToUseBreadcrumbJsonLd(meta[locale].title, url, locale),
        }}
      >
        <div className="how-to-wrapper">
          <p className="center">Release in version 0.2.0 and later</p>
          <HowToUse
            locale={locale}
            pageContext={pageContext}
            url={url}
            config={config}
          />
        </div>
      </Layout>
    );
  }
}

export default ResizeImagePage;

export const pageQuery = graphql`
  query HowToImageQuery {
    site {
      siteMetadata {
        title
        subtitle
        url
      }
    }
    mac_step1: file(relativePath: { eq: "how-to/resize-images/mac/step1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    mac_step2: file(relativePath: { eq: "how-to/resize-images/mac/step2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    mac_step3: file(relativePath: { eq: "how-to/resize-images/mac/step3.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    win_step1: file(relativePath: { eq: "how-to/resize-images/win/step1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    win_step2: file(relativePath: { eq: "how-to/resize-images/win/step2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    win_step3: file(relativePath: { eq: "how-to/resize-images/win/step3.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
